<article class="collect" [ngClass]="{'modeone': isModeOne, 'modetwo': isModeTwo}">
  <header>
    <div class="process">
      <div>&nbsp;</div>

      <ol class="steps">
        <li langkey="order_order" class="step"></li><!--Bestellung-->
        <li class="step">Karte scannen</li><!--Karte scannen  langkey="scan_card"-->
        <li class="step">Pager scannen</li><!--Pager scannen  langkey="scan_pager"-->
        <li class="step active">Abschluss</li><!--Abschluss langkey="pager_done_done"-->
      </ol>

    </div>

    <h1 langkey="done_title"></h1><!--Ihre Bestellung war erfolgreich-->
    <div inlineSVG="sot/sot-icon.svg#sot-done" flex [setSVGAttributes]="{class: 'check-icon'}"></div>
  </header>

  <div class="content">
    <div class="box">
      <h3>Deine Pagernummer lautet</h3><!--langkey="done_pagerno"-->
      <p class="code">1234565</p><!--{{order_no}}-->

      <p class="highlight">Deine Bestellung wird jetzt zubereitet.</p>
      <!--Deine Bestellung wird jetzt zubereitet. langkey="pager_done_preparing"-->

      <p>Die Getränke können nun an der Theke abgeholt werden.</p>
      <!--Die Getränke können nun an der Theke abgeholt werden. langkey="pager_done_info"-->
    </div>

    <sot-countdown [controls]="true" [countdown_sec]="20"
      (statusChanged)="countdownStatusChanged($event)"></sot-countdown>

    <p langkey="done_home" class="counter_msg highlight"></p><!--Sie werden zur Startseite weitergeleitet.-->
  </div>

  <footer *ngIf="show_questions">
    <h2>Dürfen wir Ihnen noch ein paar Fragen stellen?</h2>

    <div class="buttons">
      <a href="" class="btn active">ja</a>
      <a href="" class="btn active">nein</a>
    </div>
  </footer>
</article>